import { mapGetters } from "vuex";
import pageheader from "../../pageheader";
import utils from "../../../utils/util";
import telematicsService from "../../../api/telematics.service";
import rules from "../../../utils/rules";
export default {
  name: "update-geo-fence",
  components: { pageheader },
  data() {
    return {
      rules: rules,
      valid: true,
      isdelete: false,
      alarmsList: [],
      options: {},
      selectedAlarmData: {},
      isSelectAllEquipments: false,
      confirmdialog: false,
      isLoaderAlarms: false,
      searchContacts: null,
      searchEmails: null,
      isUpdateAlarm: false,
      isCreateAlarm: false,
      AlarmValid: true,
      AlarmValidEdit: true,
      ContactValid: true,
      alarmDialog: false,
      alarmDialogEdit: false,
      contactName: "",
      contactPhone: "",
      contactMobile: "",
      contactEmail: "",
      alarmgetId: "",
      contactDialog: false,
      isCreatingContact: false,
      input: {},
      searchMachine: null,
      selectedMachines: [],
      ZoneId: "",
      Alarmheader: [
        { text: "Name", value: "name", width: "50%" },
        { text: "Active", value: "active", width: "20%" },

        { text: "Action", value: "action", width: "30%" },
      ],
      loading: false,
      isUpdating: false,
      center: {},
      zoom: 8,
      polygonOptions: {
        strokeColor: "#880808",
        strokeOpacity: 0.8,
        strokeWeight: 5,
        fillColor: "#880808",
        fillOpacity: 0.35,
      },
      geofencePaths: [],
      userCurrentLocation: {},
      finalGeofencePaths: [],
      name: "",
      description: "",
      gettingData: false,
      parentCompaniesList: [],
      companySelected: {},
      isLoaderCust: true,
      isLoaderMachine: false,
      machinesList: [],
      selectedContact: "",
      selectedEmails: "",
      alarmName: "",
      alarmTypeList: [
        { name: "By Zone Enter", value: "ByZoneEnter" },
        { name: "By Zone Leave", value: "ByZoneLeave" },
      ],
      contactsList: [],
      emailsList: [],
      isLoaderContacts: false,

      alarmType: "ByZoneEnter",
      enableEmails: false,
      enableSms: false,
      smsList: "",
    };
  },
  watch: {
    searchMachine(val) {
      if (val != undefined && val && val.length % 2 == 0) {
        this.getMachinesDropdown(val, "");
      }
    },
  },
  computed: {
    ...mapGetters([
      "roles",
      "fullname",
      "id",
      "companyNameDropdown",
      "companyIdDropdown",
    ]),
  },
  created() {
    this.getCompanyList();
    this.getGeofenceById();
  },
  mounted() {
    this.input = utils.getInputContent("updategeofence", this.roles);
  },
  methods: {
    changeSelectAllEquipments() {
      this.selectedMachines = [];
    },
    async getMachinesDropdown(value, units) {
      this.machinesList = [];
      this.isLoaderMachine = true;
      let customerId =
        this.companyNameDropdown == "All" ||
        this.companyNameDropdown == "" ||
        this.companyNameDropdown == null
          ? ""
          : String(this.companyIdDropdown);

      let machinesList = [];
      try {
        const response = await telematicsService.getMachinesAlarms(
          customerId,
          value,
          units
        );

        if (response.isSuccess) {
          this.isLoaderMachine = false;
          machinesList = response.data.filter((e) => e.name !== "");
          let item = response.data.alarm;
          this.machinesList = machinesList;
          this.isSelectAllEquipments = item.allUnits;
        } else {
          this.isLoaderMachine = false;
          this.machinesList = [];
        }
      } catch (err) {
        this.isLoaderMachine = false;
        console.log(err);
      }
    },
    async getGeofenceById() {
      this.gettingData = true;
      try {
        let response = await telematicsService.getGeofenceById(
          this.$route.params.id
        );
        if (response && response.data) {
          this.geofencePaths = response.data.polygon;
          this.finalGeofencePaths = response.data.polygon;
          this.center =
            response.data.polygon.length > 0 ? response.data.polygon[0] : [];
          this.zoom = 15;
          this.getCurrentZoom(this.zoom);
          this.ZoneId = response.data.tuZoneId;
          this.name = response.data.name;
          this.description = response.data.description;
          let companyObj = {};
          companyObj["id"] = Number(response.data.customerId);
          companyObj["name"] = response.data.customerName;
          if (
            response.data &&
            response.data.customerId &&
            response.data.customerName
          ) {
            this.companySelected = companyObj;
          } else {
            this.companySelected = {};
          }
          this.getAlarmsList();
          this.gettingData = false;
        } else {
          this.gettingData = false;
          this.$toast.error(response.systemMessage);
        }
      } catch (err) {
        this.gettingData = false;
        this.$toast.error("Unable to get the Geofence data" + err);
      }
    },
    confirmDelete(item) {
      this.confirmdialog = true;
      this.selectedAlarmData = item;
    },
    async deleteAlarm() {
      try {
        this.isdelete = true;
        let response = await telematicsService.deleteAlarm(
          this.selectedAlarmData.id
        );
        if (response.isSuccess) {
          this.isdelete = false;
          this.$toast.success("Alarm deleted successfully");
          this.getAlarmsList();
          this.confirmdialog = false;
        } else {
          this.isdelete = false;
          this.$toast.success(response.systemMessage);
        }
      } catch (err) {
        this.isdelete = false;
        this.$toast.error("Unable to delete alarm" + err);
      }
    },
    getCurrentZoom() {
      this.polygonOptions.strokeWeight = "5";
    },
    getCurrentCenter(center) {
      this.userCurrentLocation = {
        lat: center.latLng.lat(),
        lng: center.latLng.lng(),
      };
      this.center = this.userCurrentLocation;
      this.geofencePaths = [];
      this.geofencePaths.push(this.userCurrentLocation);
      this.geofencePaths.push(this.userCurrentLocation);
    },
    async enableAlarmfun(enableAlarmdata) {
      let payload = {
        id: enableAlarmdata.id,
        enabled: enableAlarmdata.enabled,
      };
      try {
        let response = await telematicsService.updateAlarmEnabled(
          String(enableAlarmdata.id),
          payload
        );
        if (response.isSuccess) {
          this.$toast.success("Alarm status got changes successfully");
          this.getAlarmsList();
        } else {
          this.$toast.error(response.systemMessage);
        }
      } catch (err) {
        this.$toast.error("Unable to update alarm status" + err);
      }
    },
    updatePath(mvcArray) {
      this.finalGeofencePaths = [];
      for (let i = 0; i < mvcArray.getLength(); i++) {
        let p = [];
        for (let j = 0; j < mvcArray.getAt(i).getLength(); j++) {
          p.push({
            lat: mvcArray.getAt(i).getAt(j).lat(),
            lng: mvcArray.getAt(i).getAt(j).lng(),
          });
        }
        this.finalGeofencePaths = p;
      }
    },
    async updateGeofence() {
      if (this.finalGeofencePaths.length >= 3) {
        this.finalGeofencePaths.push(this.finalGeofencePaths[0]);
        this.isUpdating = true;
        try {
          let payload = {
            name: this.name,
            description: this.description,
            customerId:
              Object.keys(this.companySelected).length === 0
                ? ""
                : String(this.companySelected.id),
            customerName:
              Object.keys(this.companySelected).length === 0
                ? ""
                : this.companySelected.name,
            polygons: this.finalGeofencePaths,
            userName: this.fullname,
            modifiedBy: this.id,
          };
          let response = await telematicsService.updateGeofence(
            this.$route.params.id,
            payload
          );
          if (response.isSuccess) {
            this.$toast.success("Geofence updated successfully");
            this.isUpdating = false;
            this.$router.push({
              path: "/geofences/list",
            });
          } else {
            this.$toast.error(response.systemMessage);
            this.isUpdating = false;
          }
        } catch (err) {
          this.isUpdating = false;
          this.$toast.error("Unable to update the Geofence" + err);
        }
      } else {
        this.$toast.error("Invalid Geofence, Please draw valid Geofence.");
      }
    },
    goBack() {
      this.$router.push({
        path: "/geofences/list",
      });
    },
    openAlarmDialog() {
      this.alarmDialog = true;
      this.getAlarmContacts();
    },

    resetAlarmForm() {
      this.alarmName = "";
      this.alarmType = "ByZoneEnter";
      this.selectedMachines = [];
      this.enableEmails = false;
      this.enableSms = false;
      this.selectedEmails = "";
      this.selectedContact = "";
    },
    closeAlarmDialog() {
      this.alarmDialog = false;
      this.resetAlarmForm();
    },
    closeAlarmDialogEdit() {
      this.alarmDialogEdit = false;
      this.resetAlarmForm();
    },
    closeContactDialog() {
      this.contactDialog = false;
      this.contactName = "";
      this.contactEmail = "";
      this.contactMobile = "";
      this.contactPhone = "";
    },
    openContactDialog() {
      this.contactDialog = true;
    },
    async getCompanyList() {
      this.isLoaderCust = true;
      let finalLists = [];
      try {
        const response = await telematicsService.getBasicCustomers();
        if (response.isSuccess) {
          this.isLoaderCust = false;
          finalLists = response.data.filter((e) => e.name !== "");
          this.parentCompaniesList = finalLists;
        } else {
          this.isLoaderCust = false;
          this.parentCompaniesList = [];
        }
      } catch (err) {
        this.isLoaderCust = false;
        console.log(err);
      }
    },

    async getAlarmContacts() {
      this.isLoaderContacts = true;
      let customerId =
        Object.keys(this.companySelected).length === 0
          ? ""
          : String(this.companySelected.id);

      let contactsList = [];
      let emailsList = [];
      try {
        const response = await telematicsService.getAlarmContacts(customerId);
        if (response.isSuccess) {
          this.isLoaderContacts = false;
          contactsList = response.data;
          emailsList = response.data;

          this.contactsList = contactsList;
          this.emailsList = emailsList;
          this.isLoaderContacts = false;
        } else {
          this.isLoaderContacts = false;
          this.contactsList = [];
          this.emailsList = [];
        }
      } catch (err) {
        this.isLoaderContacts = false;
        console.log(err);
      }
    },
    // Recipient keys for the alarm payloads: an unchecked toggle sends "" even
    // when a selection is still held in state.
    alarmRecipients() {
      return {
        emailRecipients: this.enableEmails
          ? this.selectedEmails
            ? this.selectedEmails.join(",")
            : ""
          : "",
        smsRecipients: this.enableSms
          ? this.selectedContact
            ? this.selectedContact.join(",")
            : ""
          : "",
      };
    },
    async createAlarm() {
      let payload = {
        name: this.alarmName,
        type: this.alarmType,
        enabled: true,
        allUnits: this.isSelectAllEquipments,
        units: this.selectedMachines ? this.selectedMachines.join(",") : "",
        ...this.alarmRecipients(),
        zoneId: this.ZoneId,
      };
      if (this.selectedMachines.length != 0 || this.isSelectAllEquipments) {
        this.isCreateAlarm = true;
        try {
          let response = await telematicsService.CreateAlarm(payload);
          if (response.isSuccess) {
            this.$toast.success("Geofence updated successfully");
            this.isCreateAlarm = false;
            this.alarmDialog = false;
            this.getAlarmsList();
          } else {
            this.$toast.error(response.systemMessage);
            this.isCreateAlarm = false;
          }
        } catch (err) {
          this.isCreateAlarm = false;
          this.$toast.error("Unable to create the Alarm" + err);
        }
      } else {
        this.$toast.error("Please select atleast one equipment");
      }
    },
    removeequip(item) {
      const index = this.selectedMachines.indexOf(item.unitId);
      if (index >= 0) this.selectedMachines.splice(index, 1);
    },
    editAlarmDialog(item) {
      this.getMachinesDropdown();
      this.getAlarmContacts();
      this.alarmDialogEdit = true;
      this.alarmgetId = item.id;
      this.alarmName = item.name;
      this.alarmType = item.type;
      this.selectedEmails = item.emailRecipients;
      this.selectedContact = item.smsRecipients;
      if (
        this.selectedEmails.length != 0 &&
        this.selectedEmails != "" &&
        this.selectedEmails != null
      ) {
        this.enableEmails = true;
      } else {
        this.enableEmails = false;
        this.selectedEmails = "";
      }
      if (
        this.selectedContact.length != 0 &&
        this.selectedContact != "" &&
        this.selectedContact != null
      ) {
        this.enableSms = true;
      } else {
        this.enableSms = false;
        this.selectedContact = "";
      }
      this.selectedMachines = item.units;
      this.isSelectAllEquipments = item.allUnits;
    },
    async updateAlarm() {
      let payload = {
        id: this.alarmgetId,
        name: this.alarmName,
        type: this.alarmType,
        allUnits: this.isSelectAllEquipments,
        units: this.selectedMachines ? this.selectedMachines.join(",") : "",
        ...this.alarmRecipients(),
        zoneId: this.ZoneId,
      };
      if (this.selectedMachines.length != 0 || this.isSelectAllEquipments) {
        this.isUpdateAlarm = true;

        try {
          let response = await telematicsService.UpdateAlarm(
            this.alarmgetId,
            payload
          );
          if (response.isSuccess) {
            this.$toast.success("Alarm updated successfully");
            this.isUpdateAlarm = false;
            this.alarmDialogEdit = false;
            this.getAlarmsList();
            this.closeAlarmDialogEdit();
          } else {
            this.$toast.error(response.systemMessage);
            this.isUpdateAlarm = false;
          }
        } catch (err) {
          this.isUpdateAlarm = false;
          this.$toast.error("Unable to update the Alarm" + err);
        }
      } else {
        this.$toast.error("Please select atleast one machine");
      }
    },
    async createContact() {
      let customerId =
        Object.keys(this.companySelected).length === 0
          ? ""
          : String(this.companySelected.id);

      var outPhone = this.contactPhone.replace(/[^a-zA-Z0-9]/g, "");
      var outMobile = this.contactMobile.replace(/[^a-zA-Z0-9]/g, "");
      let payload = {
        name: this.contactName,
        email: this.contactEmail,
        phone: outPhone,
        mobile: outMobile,
      };
      try {
        let response = await telematicsService.CreateAlarmContacts(
          customerId,
          payload
        );
        if (response.isSuccess) {
          this.$toast.success("Contact updated successfully");
          this.isCreatingContact = false;
          this.contactDialog = false;
          this.getAlarmContacts();
        } else {
          this.$toast.error(response.systemMessage);
          this.isCreatingContact = false;
        }
      } catch (err) {
        this.isCreatingContact = false;

        this.$toast.error("Unable to create the Contact" + err);
      }
    },

    async getAlarmsList() {
      this.isLoaderAlarms = true;
      let alarmsList = [];
      try {
        const response = await telematicsService.getAlarmsList(this.ZoneId);
        if (response.isSuccess) {
          this.isLoaderAlarms = false;
          alarmsList = response.data.filter((e) => e.name !== "");

          this.alarmsList = alarmsList;
        } else {
          this.isLoaderAlarms = false;
          this.alarmsList = [];
        }
      } catch (err) {
        this.isLoaderAlarms = false;

        console.log(err);
      }
    },
    updateRouterParams() {
      this.$router.push(
        `/geofences/list?filterVal=${this.$route.query.filterVal}&isFilter=${this.$route.query.isFilter}`
      );
    },
  },
};
